import React from 'react'
import RoadsideAssistanceContent from '../../src/components/RoadsideAssistanceContent'
import Footers from '../../src/components/Footer'
import Header from '../../src/components/Header'

export default function ContactPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <RoadsideAssistanceContent state={'NJ'}/>
      </div>
      <Footers />
    </>
  )
}
